export default __webpack_public_path__ + "static/media/balloons.85dd1697.png";